import { createFileRoute } from '@tanstack/react-router'
import Profitability from 'Profitability/components/Profitability'

import { Guard } from '../../-guard'

export const Route = createFileRoute('/concept/$conceptId/profitability')({
    component: () => (
        <Guard features={['profitability']}>
            <Profitability />
        </Guard>
    ),
})
